<template>
  <div>
    <!--弹窗-->
    <div class="toast-bg" v-show="loadingFlag">
      <div class="toast-me middle toast-me2">
        <img src="../assets/img/loading.gif" alt="" />
      </div>
    </div>
    <div class="toast-bg" style="z-index: 9999" v-show="detailFlag">
      <div class="toast-me middle">
        <div class="toast-tit">维修单明细</div>
        <div class="toast-main">
          <div class="toast-tit2">用户应付款</div>
          <div class="toast-item-wrap">
            <div class="toast-item" v-for="(item, index) in ServiceSheetFeeInfo" :key="index">
              <span class="toast-label">{{ item.feeType }}</span>
              <span class="toast-num">{{ item.fee }}</span>
            </div>
            <div class="toast-item">
              <span class="toast-label">合计：</span>
              <span class="toast-num">{{ total }}</span>
            </div>
          </div>
        </div>
        <div class="question-btns" style="background: none">
          <a href="javascript:" class="submit-btn" @click="detailFlag = false" style="margin-right: 30px">确定</a>
          <a href="javascript:" class="submit-btn" @click="showPay = !showPay">去支付</a>
        </div>

        <div class="pay" v-show="showPay">
          <div @click="wxpayCreate">
            <img class="wxpay" src="../assets/img/wxpay.png" alt="微信支付" title="微信支付" />
            <!-- <div>微信支付</div> -->
          </div>
          <!-- <div @click="alipayCommon">
            <img
              class="alipay"
              src="../assets/img/alipay.png"
              alt="支付宝支付"
              title="支付宝支付"
            />
            
          </div> -->
        </div>
      </div>
    </div>
    <div class="toast-bg" v-show="tmsFlag">
      <div class="toast-me middle">
        <div class="toast-tit">物流明细</div>
        <div style="max-height: 50vh; overflow-y: auto;">
          <el-steps direction="vertical" space="80px" process-status="finish" :active="0">
            <el-step :title="'【' + item.trackingTypeSc + '】' + ' ' + item.trackingDate" :description="item.remark"
              :key="index" icon="el-icon-location-information" v-for="(item, index) in tmsLists"></el-step>
          </el-steps>
        </div>
        <div class="question-btns" style="background: none">
          <a href="javascript:" class="submit-btn" @click="tmsFlag = false" style="margin-right: 30px">确定</a>
        </div>
      </div>
    </div>
    <div class="center">
      <div class="main-wrap2">
        <div class="detail-page-nav">
          <a href="javascript:">首页 <i> &gt; </i></a>
          <a href="javascript:">在线预约及查询 <i> &gt; </i></a>
          <a href="javascript:" class="active">预约查询</a>
        </div>
        <div class="banner">
          <img src="../assets/img/inquire-img.png" alt="" />
        </div>
        <div class="mainContent">
          <div class="show-part input-groups">
            <div class="reservation-category">查询方法</div>
            <div class="products">
              <span>查询类别：</span>
              <a href="javascript:" :class="{
                  active: reservationFlag == true && repairFlag == false,
                }" @click="
                  reservationFlag = true;
                  repairFlag = false;
                ">预约查询</a>
              <a href="javascript:" :class="{
                  active: repairFlag == true && reservationFlag == false,
                }" @click="repaireFun">维修查询</a>
              <a href="javascript:" :class="{ active: reservationFlag && repairFlag }" @click="inquireFun">全部查询</a>
            </div>
            <div class="select-item clearfix">
              <div class="item-left fl">
                <label for="phoneNum" class="item-label">手机号：</label>
                <input id="phoneNum" type="text" class="number-input" v-model="phoneNum" />
              </div>
              <div class="fl item-left" v-show="reservationFlag" style="margin-bottom: 16px">
                &nbsp;&nbsp;&nbsp;&nbsp;<label for="reservationNum" class="item-label">预约号：</label>
                <input id="reservationNum" type="text" class="number-input" v-model="reservationNum"
                  @keyup="upperFun('reservationNum')" />
              </div>
              <div class="fl item-left" v-show="repairFlag" style="margin-bottom: 16px">
                <span class="star" v-show="spaceFlag"></span>
                <label for="repairNum" class="item-label">维修号：</label>
                <input id="repairNum" type="text" class="number-input" v-model="repairNum"
                  @keyup="upperFun('repairNum')" />
              </div>
            </div>
            <div class="select-item clearfix" style="margin-left: -12px">
              <div class="fl item-left">
                <span class="star">*</span><label for="verificationNum" class="item-label">验证码：</label>
              </div>
              <div class="item-left verification-input fl">
                <input id="verificationNum" type="text" class="name-input" v-model="verificationNum" />
                <img :src="imgsrc" alt="" @click="refreshImg" />
              </div>
            </div>
            <div class="notice notice-query">
              <span class="notice_tit">注意事项：</span>
              <span class="notice-text">请至少输入一个查询条件</span>
            </div>
          </div>
        </div>
        <div class="question-btns">
          <a href="javascript:" class="back-btn" @click="resetHandle">重置</a>
          <a href="javascript:" class="submit-btn" @click="submitQuerry">提交</a>
        </div>
      </div>
    </div>
    <div class="results2" v-show="resultsFlag">
      <div class="center">
        <div class="tit">查询结果</div>
        <table class="results-table2">
          <thead>
            <tr>
              <th style="text-align: center">序号</th>
              <th>预约单号</th>
              <th>维修单号</th>
              <th>产品型号</th>
              <th>物流单号</th>
              <th>支付价格</th>
              <th>维修状态</th>
              <th>支付状态</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in queryLists" :key="index">
              <td class="left-type">{{ index + 1 }}</td>
              <td>
                {{
                item.reserveSheetNo ? item.reserveSheetNo.toUpperCase() : "__"
                }}
              </td>
              <td>
                {{
                item.serviceSheetNo ? item.serviceSheetNo.toUpperCase() : "__"
                }}
              </td>
              <td>{{ item.productmodel }}</td>
              <td v-if="item.tmsId">
                <a class="tips-a" href="javascript:" @click="showTms(item.tmsId)">{{ item.tmsId.toUpperCase() }}</a>
              </td>
              <td v-else>__</td>
              <td v-if="item.status != '付机'">{{ item.total ? item.total : "__" }}</td>
              <td v-else>__</td>
              <td>{{ item.status }}</td>
              <td v-if="item.status != '付机'" :class="{ active: item.payStatus === '未付款' }" @click="getDetail(item)">
                {{ item.payStatus }}>
              </td>
              <td v-else>__</td>
            </tr>
          </tbody>
        </table>
        <div class="tit" v-show="noData">没有数据</div>
      </div>
    </div>
    <!-- <div class="notice notice-query tips">
      索尼推出 “省心送返” 服务，详情请点击<a
        class="tips-a"
        href="https://service.sony.com.cn/service/songfan/index.html"
        target="_blank"
        >此处</a
      >
    </div> -->

    <systemNotice></systemNotice>
    <login></login>
  </div>
</template>
<script>
// @ is an alias to /src
import login from "../components/login"
import systemNotice from "../components/system-notice"
import { regs, isMobileDevice } from "../common/utils/pageCtents";
import api from "../common/utils/api";
import http from "axios";
export default {
  name: "home",
  components: {systemNotice, login},
  data() {
    return {
      ServiceSheetFeeInfo: [],
      loadingFlag: false,
      total: "",
      orderStatusFlag: "",
      serviceSheetNo: "",
      dataCount: 0,
      pageSize: 6,
      noData: false,
      resultsFlag: false,
      logisticPay: "",
      technicalFee: "",
      detailFlag: false,
      reservationFlag: true,
      repairFlag: false,
      imgsrc: "",
      reservationNum: "",
      repairNum: "",
      verificationNum: "",
      phoneNum: "",
      spaceFlag: false,
      queryLists: [],
      count: 0,
      tmsFlag: false,
      tmsLists: [],
      showPay: false,
      ascid: "",
    };
  },
  methods: {
    upperFun(attr) {
      let str = this[attr];
      this[attr] = str.toUpperCase();
    },

    //微信支付-创建订单
    //WES2200021102900041
    //HEI2200020071400014
    wxpayCreate() {
      this.loadingFlag = true;
      //封装请求参数
      let url = api.reservation.createOrder();
      let params = {
        totalFeeOld: this.total,
        channel: "wx",
        organizationCode: this.ascid,
        serviceSheetNo: this.serviceSheetNo,
        payType: "W01",
      };
      http
        .post(url, params)
        .then((res) => {
          this.loadingFlag = false;
          if (res.data.stateCode != 1) {
            this.$toast({
              show: true,
              message: res.data.message,
              position: "top",
              during: 2500,
            });
            return;
          }
          //去支付
          let routerParams = {
            total: this.total,
            codeUrl: res.data.data.payinfo,
            orderSn: res.data.data.reqsn,
            outSn: res.data.data.reqsn,
            serviceSheetNo: this.serviceSheetNo,
            clientSn: res.data.data.clientSn,
            storeSn: res.data.data.cusid
          }
          let payUrl = this.$router.resolve({
            name: "wxpay"
          });
          localStorage.setItem("wxpayParams", JSON.stringify(routerParams))
          window.open(payUrl.href, "_blank");
        })
        .catch((error) => {
          this.loadingFlag = false;
          console.log(error);
        });
    },
    // 定时查询订单状态
    getStatus() {
      // let timer2 = null
      // let orderData = ''
      // timer2 = setTimeout(async () => {
      //   console.log('this.count:', this.count)
      //   if (this.count === 5) {
      //     clearTimeout(timer2)
      //     this.count = 0
      //     if (this.orderStatusFlag) {
      //       return true
      //     } else {
      //       return false
      //     }
      //   } else {
      //     this.count++
      //     orderData = await this.orderStatus()
      //     if (orderData && orderData.returnCode === '0') {
      //       if (orderData.serviceSheetDtl[0].payStatus === '未付款') { this.orderStatusFlag = true }
      //       clearTimeout(timer2)
      //       return true
      //     } else {
      //       this.orderStatusFlag = false
      //       this.getStatus()
      //     }
      //   }
      // }, 1000)
    },
    // 支付
    goPay(SheetNo) {
      return new Promise((resolve, reject) => {
        let url = api.reservation.payService();
        http({
          method: "GET",
          url: url,
          params: {
            serviceSheetNo: SheetNo,
          },
        })
          .then((res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 支付宝支付
    alipayCommon() {
      let SheetNo = this.serviceSheetNo;
      let payData = this.goPay(SheetNo);
      payData
        .then(async (res) => {
          console.log("支付：", res);
          if (res.data.returnCode === "0") {
            console.log("进入了支付");
            document.body.innerHTML = res.data.message;
            document.forms[0].submit();
          }
        })
        .catch((error) => {
          alert(error);
        });
    },
    orderStatus() {
      return new Promise((resolve, reject) => {
        let url = api.reservation.queryStatus();
        if (!this.verificationNum) {
          this.$toast({
            show: true,
            message: "请填写验证码",
            position: "top",
            during: 3000,
          });
        } else {
          if (this.checkInputs()) {
            http({
              method: "get",
              url: url,
              params: {
                mobile: this.phoneNum,
                reserveSheetNo: this.reservationNum,
                serviceSheetNo: this.repairNum,
                vaildCode: this.verificationNum,
              },
            })
              .then((res) => {
                if (res.data.returnCode === "1") {
                  let message = res.data.message;
                  this.$toast({
                    show: true,
                    message: message,
                    position: "top",
                    during: 3000,
                  });
                } else if (res.data.returnCode === "0") {
                  resolve(res.data);
                }
              })
              .catch((error) => {
                reject(error);
              });
          }
        }
      });
    },
    showTms(tmsId) {
      // tmsId = "P221021171737418"; // build时删掉
      let url = api.reservation.getTmsStatus();
      http({
        method: "GET",
        url: url,
        params: {
          tmsId: tmsId,
        },
      })
        .then((res) => {
          if(res.data.stateCode != 1) {
            this.$toast({
              show: true,
              message: "暂时没有物流信息！",
              position: "top",
              during: 2500,
            });
          } else {
            this.tmsLists = res.data.data;
            this.tmsFlag = true;
          }      
        })
        .catch((error) => {
          this.$toast({
            show: true,
            message: "暂时没有物流信息！",
            position: "top",
            during: 2500,
          });
        });
    },
    getDetail(item) {
      if (item.payStatus === "未付款" && item.serviceSheetFeeInfo.length > 0 && (item.status === "计价" || item.status === "重新计价")) {
        this.detailFlag = true;
        this.serviceSheetNo = item.serviceSheetNo;
        this.ServiceSheetFeeInfo = item.serviceSheetFeeInfo;
        this.total = item.total;
        this.ascid = item.ascid;
        localStorage.setItem("total", this.total);
      } else {
        this.$toast({
          show: true,
          message: "现在还不能支付！",
          position: "top",
          during: 2500,
        });
      }
    },
    repaireFun() {
      this.reservationFlag = false;
      this.repairFlag = true;
      this.spaceFlag = true;
    },
    inquireFun() {
      this.reservationFlag = true;
      this.repairFlag = true;
      this.spaceFlag = false;
    },
    getCode() {
      let urlRaw = api.reservation.vallicode();
      this.imgsrc = urlRaw + "?stamp=" + Date.now();
    },
    refreshImg() {
      this.getCode();
    },
    resetHandle() {
      this.reservationNum = "";
      this.repairNum = "";
      this.phoneNum = "";
    },
    checkInputs() {
      // 预约查询和维修查询
      if (this.reservationFlag && !this.repairFlag) {
        if (!this.phoneNum && !this.reservationNum) {
          this.$toast({
            show: true,
            message: "请填写正确的预约单号或手机号！",
            position: "top",
            during: 2500,
          });
          return false;
        }
      } else if (this.repairFlag && !this.reservationFlag) {
        if (!this.phoneNum && !this.repairNum) {
          this.$toast({
            show: true,
            message: "请填写正确的维修单号或手机号！",
            position: "top",
            during: 2500,
          });
          return false;
        }
      }
      // 验证码
      if (!this.verificationNum) {
        this.$toast({
          show: true,
          message: "请填写验证码",
          position: "top",
          during: 3000,
        });
        return false;
      }
      // 全部查询
      if (this.reservationFlag && this.repairFlag) {
        if (this.phoneNum) {
          if (!this.checkSingle(this.phoneNum.trim(), "telPhone")) {
            this.$toast({
              show: true,
              message: "请填写正确的手机号！",
              position: "top",
              during: 2500,
            });
            return false;
          }
        }
        if (!this.phoneNum && !this.repairNum && !this.reservationNum) {
          this.$toast({
            show: true,
            message: "请填写正确的维修单号或预约单号或手机号！",
            position: "top",
            during: 2500,
          });
          return false;
        }
      }
      return true;
    },
    checkSingle(value, type) {
      let reg = new RegExp(regs[type]);
      if (reg.test(value)) {
        return true;
      } else {
        return false;
      }
    },

    submitQuerry() {
      // console.log('document.documentElement.clientHeight:', document.documentElement.scrollHeight)
      // let height = 1918
      // let number = 0 // 控制结束累加器
      // let length = 0 // 控制每次翻滚长度
      // let frequency = 120 // 控制总时间
      // let time = setInterval(function () {
      //   number += 1
      //   if (number === frequency + 1) {
      //     clearInterval(time)
      //   } else {
      //     length += height / frequency
      //     document.documentElement.scrollTop = length
      //   }
      // }, 1000) // 每隔1S翻滚
      let url = api.reservation.queryStatus();
      if (this.checkInputs()) {
        console.log("校验通过");
        this.loadingFlag = true;
        window.scrollTo(0, 1918);
        http({
          method: "post",
          url: url,
          params: {
            mobile: this.phoneNum.trim(),
            reserveSheetNo: this.reservationNum.trim(),
            serviceSheetNo: this.repairNum.trim(),
            vaildCode: this.verificationNum.trim(),
          },
        })
          .then((res) => {
            this.queryLists = [];
            this.loadingFlag = false;
            this.getCode();
            this.resultsFlag = true;
            if (Number(res.data.stateCode) === 1) {
              this.noData = false;
              this.queryLists = res.data.data;
              console.log("this.queryLists:", this.queryLists);
            } else if (Number(res.data.stateCode) === 0) {
              this.noData = true;
              let message = res.data.message;
              this.$toast({
                show: true,
                message: message,
                position: "top",
                during: 3000,
              });
            }
          })
          .catch((error) => {
            this.loadingFlag = false;
            this.noData = true;
            this.getCode();
            console.log(error);
          });
      }
    },
    homePageAA(){
      console.log('AA',this.$route.path,this.$route.name);
      window.digitalData={
        page:{
          pageInfo:{
            pageURL: window.location.href,	
            pageName: 'best:' + this.$route.name,	//页面名称，必填变量
            pageTitle: 'best:' + this.$route.name,	
            siteSection: "best"	//网站区域，必填
          }
        }
      };
    }
  },
  mounted() {
    this.getCode();
    console.log("test");
    // $(function() {
    //   $(".agree").click(function() {
    //     $(this).toggleClass("check");
    //   });
    // });
  },
  created() {
    this.homePageAA();
  },

  beforeCreate() {
    if (isMobileDevice()) {
      console.log("is mobile device");
      window.location = "/mobilesite/index.html#/inquire";
    }
  },
};
</script>
<style>
@import url("../assets/css/common.css");
@import url("../assets/css/index.css");
@import url("../assets/css/inquire.css");
</style>
<style scoped>
.tips {
  font-size: 18px;
  width: 1200px;
  margin: 20px auto 20px auto;
}
.tips-a {
  color: #0190e1;
}
.pay {
  display: flex;
  justify-content: center;
}
.wxpay {
  width: 50px;
  margin-right: 20px;
}
.alipay {
  width: 65px;
}
</style>
